import { environment } from '@skylab/environments';
import { EventBus } from '../event';

interface LoggerContext {
    readonly prefix: string;

    enabled: boolean;
}

export enum ConsoleLoggerEvents {
    Error = 'Error'
}

export class ConsoleLogger {
    private readonly context: LoggerContext;

    public constructor(prefix = '') {
        this.context = {
            prefix,
            enabled: !!environment.dev
        };
    }

    public info(arg: any, description?: string): void {
        this.context.enabled && console.info(this.getEnchancedMessage(description), arg);
    }

    public warn(arg: any, description?: string): void {
        this.context.enabled && console.warn(this.getEnchancedMessage(description), arg);
    }

    public error(arg: any, description?: string): void {
        EventBus.emit(ConsoleLoggerEvents.Error, {error: arg, description});
        console.error(this.getEnchancedMessage(description), arg);
    }

    public disable(): void {
        this.context.enabled = false;
    }

    private getEnchancedMessage(description?: string): string {
        const time = `[${this.getTime()}]`;
        const prefix = `[${this.context.prefix}]`;
        return [time, prefix, '→', description && description + ' →'].filter(v => !!v).join(' ');
    }

    private getTime(): string {
        const date: Date = new Date();
        const dateString: string = date.toTimeString();
        const timeRegexp = /^([0-9]{2}:[0-9]{2}:[0-9]{2})/;
        const match = dateString.match(timeRegexp);

        return match ? match[0] : '';
    }
}
